/* tslint:disable:max-line-length */
import * as React from 'react';

import * as styles from '../../../Styles/svgShadow.css';

const IconCaptionsInactive = () => (
    <svg viewBox="0 0 100 100" className={styles.svgShadow}>
        <path d="M89.025,65.766l-9.42,9.42H48.654l-21.98,12.56v-12.56h-6.28l-9.42-9.42V31.675l9.42-9.42h59.21l9.42,9.42
        V65.766z M84.988,63.971V33.469l-7.177-7.177H22.189l-7.177,7.177v30.502l7.177,7.177h4.486h4.037v9.42l16.597-9.42h30.502
        L84.988,63.971z M29.366,54.551h18.84v-4.037h-18.84V54.551z M29.366,45.132h40.371v-4.037H29.366V45.132z"/>
    </svg>
);

export default IconCaptionsInactive;